/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const marketingRouter = {
	path: '/marketing',
	component: Layout,
	redirect: 'noRedirect',
	name: '营销',
	id: 500000,
	meta: {
		title: '营销',
		icon: 'component',
		roles: [500000]
	},
	children: [
		{
			path: 'timelimit',
			component: () =>
				import(/* webpackChunkName: "timelimit" */ '@/leniuview/marketing/timelimit'),
			name: '消费规则',
			id: 502000,
			meta: {
				title: 'marketing.timelimit',
				roles: [502000]
			}
		},
		{
			path: 'eatingRules',
			component: () =>
				import(/* webpackChunkName: "eatingRules" */ '@/leniuview/marketing/eatingRules'),
			name: '就餐权限',
			id: 503000,
			meta: {
				title: '就餐权限',
				roles: [503000]
			}
		},
		// {
		//   path: "hongbao",
		//   component: () =>
		//     import(/* webpackChunkName: "hongbao" */ "@/leniuview/marketing/hongbao"),
		//   name: "红包设置",
		//   id: 506000,
		//   meta: {
		//     title: "marketing.hongbao",
		//     roles: [506000]
		//   }
		// },
		{
			path: 'repaidgift',
			component: () =>
				import(/* webpackChunkName: "repaidgift" */ '@/leniuview/marketing/repaidgift'),
			name: '充值配置规则',
			id: 507000,
			meta: {
				title: 'marketing.repaidgift',
				roles: [507000]
			}
		},
		{
			path: 'paperCoupon',
			component: LayoutView,
			name: '纸质餐券',
			id: 515000,
			meta: {
				title: '纸质餐券',
				roles: [515000]
			},
			children: [
				{
					path: 'template',
					component: () => import('@/leniuview/marketing/paperCoupon/template'),
					name: '模板',
					meta: { title: '模板', roles: [515100] }
				},
				{
					path: 'make',
					component: () => import('@/leniuview/marketing/paperCoupon/make'),
					name: '制作发放',
					meta: { title: '制作发放', noCache: true, roles: [515200] }
				},
				{
					path: 'receive',
					component: () => import('@/leniuview/marketing/paperCoupon/receive'),
					name: '领取记录',
					meta: { title: '领取记录', roles: [515300] }
				},
				{
					path: 'detail',
					component: () => import('@/leniuview/marketing/paperCoupon/detail'),
					name: '餐券明细',
					meta: { title: '餐券明细', roles: [515400] }
				},
				{
					path: 'summary',
					component: () => import('@/leniuview/marketing/paperCoupon/summary'),
					name: '餐券汇总',
					meta: { title: '餐券汇总', roles: [515500] }
				}
			]
		},
		{
			path: 'electronCoupon',
			component: LayoutView,
			name: '电子餐券',
			id: 516000,
			meta: {
				title: '电子餐券',
				roles: [516000]
			},
			children: [
				{
					path: 'template',
					component: () =>
						import('@/leniuview/marketing/electronCoupon/template'),
					name: '模板',
					meta: { title: '模板', roles: [516100] }
				},
				{
					path: 'make',
					component: () => import('@/leniuview/marketing/electronCoupon/make'),
					name: '制作发放',
					meta: { title: '制作发放', roles: [516200], noCache: true }
				},
				{
					path: 'regularTemplate',
					component: () =>
						import('@/leniuview/marketing/electronCoupon/regularTemplate'),
					name: '定时发放',
					meta: { title: '定时发放', roles: [516300] }
				},
				{
					path: 'summary',
					component: () =>
						import('@/leniuview/marketing/electronCoupon/summary'),
					name: '餐券汇总',
					meta: { title: '餐券汇总', roles: [516400] }
				}
			]
		},
		// {
		//   path: "cancelorder",
		//   component: () =>
		//     import(/* webpackChunkName: "cancelorder" */ "@/leniuview/marketing/cancelOrder"),
		//   name: "退款规则",
		//   id: 513000,
		//   meta: {
		//     title: "marketing.cancelorder",
		//     roles: [513000]
		//   }
		// },
		{
			path: 'detail',
			component: () =>
				import(/* webpackChunkName: "detail" */ '@/leniuview/marketing/detail'),
			name: '领取记录',
			meta: {
				title: 'marketing.hongbaojilu',
				roles: [506000]
			},
			hidden: true
		}
		// {
		//   path: "managerule",
		//   component: () => import("@/leniuview/marketing/coupon"),
		//   name: "管理费规则",
		//   meta: {
		//     title: "marketing.managerule"
		//   },
		//   hidden: true
		// },
	]
}

export default marketingRouter
